import { format } from 'date-fns';
import moment from 'moment';

type FormatDateType = { date: string; time: string };

export const formatDate = (dateString: string): FormatDateType => {
  const date = new Date(dateString);

  const optionsDate: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  };
  const formattedDate = new Intl.DateTimeFormat('pt-BR', optionsDate).format(date);

  const optionsTime: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  const formattedTime = new Intl.DateTimeFormat('pt-BR', optionsTime).format(date);

  return { date: formattedDate, time: formattedTime };
};

export const formatFirstInstallmentDate = (dateString: string): string => {
  const [year, month, day] = dateString.split('-');

  const date = new Date(Number(year), Number(month) - 1, Number(day), 12);

  const optionsDate: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('pt-BR', optionsDate);
};

export const formatCNPJ = (cnpj: string): string => {
  if (!cnpj) return '';
  const cleanCNPJ = cnpj.toUpperCase().replace(/[^A-Z0-9]/g, '');

  if (cleanCNPJ.length !== 14) {
    return cnpj;
  }

  return cleanCNPJ.replace(/^([a-zA-Z0-9]{2})([a-zA-Z0-9]{3})([a-zA-Z0-9]{3})([a-zA-Z0-9]{4})(\d{2})$/, '$1.$2.$3/$4-$5');
};

export const getHourAndMinutes = (dateString) => {
  const date = new Date(dateString);
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}`;
};

export const formatDateAndHour = (dateString?: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
};

export const formatDateSimple = (dateString: string): string => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const formatDateForToast = (dateString?: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);

  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
    .format(date)
    .replace(',', ' às');
};

export const dateTimeFormat = (dateString: string) => {
  if (!dateString) return '';

  const date = new Date(dateString.replace('Z', ''));

  return format(date, 'dd/MM/yyyy HH:mm:ss');
};

export const dateTimeAMPMFormat = (dateString?: string) => {
  if (!dateString) return '';
  const date = new Date(dateString);

  return format(date, 'dd/MM/yyyy hh:mm a');
};

export const formatShortMonthDate = (dateString: string): string => {
  const [year, month, day] = dateString.split('-');

  const date = new Date(Number(year), Number(month) - 1, Number(day), 12);

  const optionsDate: Intl.DateTimeFormatOptions = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };

  const formattedDate = date.toLocaleDateString('pt-BR', optionsDate).replace('.', '');

  const [dayMonth, yearFormatted] = formattedDate.split(' de ').slice(0, 2);
  return `${dayMonth} de ${yearFormatted}, ${date.getFullYear()}`;
};

export function currentMonthName(): string {
  const m = moment().locale('pt-br').format('MMMM');
  return m.charAt(0).toUpperCase() + m.slice(1);
}
